import { createLogger as createClientLogger } from './clientLogger';
import { createLogger as createServerLogger } from './serverLogger';

export const createLogger = ({ client, server }: { client: boolean; server: boolean }) => {
    // @ts-ignore
    return global.__SERVER__ ? createServerLogger(server) : createClientLogger(client);
};
